import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ModalCopyProgram = ({ isVisible, onClose, choosenPinCode }) => {
    const [dataDevice, setDataDevice] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const token = localStorage.getItem("token");

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/InterfaceTizenDevice`)
            .then(res => setDataDevice(res.data))
            .catch(err => console.log(err));
    }, []);

    const handleClose = (e) => {
        if (e.target.id === "wrapper") onClose();
    };

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };

    const copyProgram = (_pin_code_source) => {
    // 1. Récupérer les programmes
    axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_programme`, {
        _pin_code: _pin_code_source
    })
    .then(res => {
        // 2. Une fois les programmes récupérés, lancer la suppression
        const data = { _pin_code: choosenPinCode };
        
        // On retourne la promesse de suppression pour chaîner
        return axios.delete(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/delete_old_prog`, { headers, data })
            .then(() => {
                // 3. CE BLOC s'exécute SEULEMENT APRÈS la réussite de la suppression
                console.log("Programme par défaut supprimé. Début de la copie...");

                // Préparer les requêtes d'ajout
                const postRequests = res.data.map(prog => {
                    prog._pin_code = choosenPinCode;
                    prog.StartTime = new Date(prog.StartTime);
                    prog.EndTime = new Date(prog.EndTime);
                    prog.StartTime = [
                        prog.StartTime.getFullYear(),
                        prog.StartTime.getMonth() + 1,
                        prog.StartTime.getDate()
                    ].join('-') + ' ' + prog.heureDebut;
                    prog.EndTime = [
                        prog.EndTime.getFullYear(),
                        prog.EndTime.getMonth() + 1,
                        prog.EndTime.getDate()
                    ].join('-') + ' ' + prog.heureFin;
            
                    return axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/add_programme`, prog);
                });
                
                return Promise.all(postRequests);
            });
    })
    .then(() => {
        console.log("Tous les programmes ont été copiés avec succès.");
        window.location.reload();
    })
    .catch(err => {
        console.error("Une erreur est survenue lors de la copie:", err);
    });
};

    

    if (!isVisible) return null;

    const filteredDevices = dataDevice.filter(device =>
        `${device._client_name} ${device._app_type} ${device._pin_code}`
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
    );

    return (
        <div className="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex justify-center items-center" id="wrapper" onClick={handleClose}>
            <div className="bg-white rounded-lg p-6 w-[92vw] max-w-[800px]">
                <button className="text-black text-xl float-right mb-4" onClick={onClose}>X</button>
                <h2 className="text-lg font-semibold mb-4">Sélectionner un client pour copier le programme</h2>

                <input
                    type="text"
                    placeholder="Rechercher un client, type d'app ou pin code..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="mb-4 w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <div className="overflow-auto max-h-[400px]">
                    <table className="min-w-full text-sm text-left text-slate-900 border">
                        <thead className="bg-slate-200 sticky top-0">
                            <tr>
                                <th className="px-4 py-2">Nom Client</th>
                                <th className="px-4 py-2">Type App</th>
                                <th className="px-4 py-2">Pin Code</th>
                                <th className="px-4 py-2">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredDevices.map((device, idx) => (
                                <tr key={idx} className="border-t hover:bg-slate-100">
                                    <td className="px-4 py-2">{device._client_name}</td>
                                    <td className="px-4 py-2">{device._app_type}</td>
                                    <td className="px-4 py-2">{device._pin_code}</td>
                                    <td className="px-4 py-2">
                                        <button
                                            onClick={() => copyProgram(device._pin_code)}
                                            className="text-white bg-blue-600 hover:bg-blue-700 px-3 py-1 rounded text-sm"
                                        >
                                            Copier
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            {filteredDevices.length === 0 && (
                                <tr>
                                    <td colSpan="4" className="text-center py-4 text-slate-500">Aucun résultat trouvé</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ModalCopyProgram;
